import { BlockSchema } from './Block.types';
import { HeadBlockConfigSchema } from './blockConfig/Types';
import { z } from 'zod';

export const HeadBlockSchema = BlockSchema.extend({
  blockConfig: HeadBlockConfigSchema,
});

export type HeadBlock = z.infer<typeof HeadBlockSchema>;
